import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as jspreadsheet from 'jspreadsheet-ce';
import { ForecastWeekEditable } from '../../services/forecast-week-editable.service';
import { CampaignUpdate } from './CampaignUpdate';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-forecast-week',
	templateUrl: './forecast-week.component.html',
})
export class ForecastWeekComponent implements AfterViewInit {
	@ViewChild('sheet', { static: true }) sheet: ElementRef;

	private campaingUpdate: CampaignUpdate = new CampaignUpdate(0, 0, 0);
	campaignList: any = [];
	campaignTypeList: any = [];
	campaignPeriods: any = [];
	isHidden: boolean = false;
	public selectedCampaign: number;
	public selectedTypeCampaign: string;
	keyword = 'name';
	isSearch: boolean = false;
	fechas: any;
	days: any;

	constructor(private forecastWeekEditable: ForecastWeekEditable) {}

	ngAfterViewInit() {
		const monday_1 = getNextMonday(new Date(), 7).toDateString().slice(4);
		const monday_2 = getNextMonday(new Date(), 14).toDateString().slice(4);
		const monday_3 = getNextMonday(new Date(), 21).toDateString().slice(4);
		const monday_4 = getNextMonday(new Date(), 28).toDateString().slice(4);
		const monday_5 = getNextMonday(new Date(), 35).toDateString().slice(4);
		const monday_6 = getNextMonday(new Date(), 42).toDateString().slice(4);
		const monday_7 = getNextMonday(new Date(), 49).toDateString().slice(4);
		const monday_8 = getNextMonday(new Date(), 56).toDateString().slice(4);

		var promise = Promise.resolve(
			this.forecastWeekEditable.getForecastLeads(),
		);
		promise.then((value) => {
			var changed = (
				instance: any,
				cell: any,
				x: any,
				y: any,
				value: any,
			) => {
				var cellName = jspreadsheet.getColumnNameFromId([x, y]);
				var rowInt = parseInt(y) + 1;

				var campaignId = tableWeek.getLabel('B' + rowInt);
				var leadsAssigned = value;
				var getDays = x;

				if (x == 5) {
					this.days = 7;
					tableWeek.setValue('G' + rowInt, 1, 1);
				}
				if (x == 7) {
					this.days = 14;
					tableWeek.setValue('I' + rowInt, 1, 1);
				}
				if (x == 9) {
					this.days = 21;
					tableWeek.setValue('K' + rowInt, 1, 1);
				}
				if (x == 11) {
					this.days = 28;
					tableWeek.setValue('M' + rowInt, 1, 1);
				}
				if (x == 13) {
					this.days = 35;
					tableWeek.setValue('O' + rowInt, 1, 1);
				}
				if (x == 15) {
					this.days = 42;
					tableWeek.setValue('Q' + rowInt, 1, 1);
				}
				if (x == 17) {
					this.days = 49;
					tableWeek.setValue('S' + rowInt, 1, 1);
				}
				if (x == 19) {
					this.days = 56;
					tableWeek.setValue('U' + rowInt, 1, 1);
				}

				if (x > 4 && x < 21) {
					// tableWeek.resetStyle(cellName);
					// if(value == 0){
					// 	tableWeek.setStyle(cellName, 'background-color','#ffbcb8');
					// }else{
					// 	tableWeek.setStyle(cellName, 'background-color','#e2ffc9');
					// }
					//  tableWeek.setStyle('B'+rowInt, 'background-color' , '#000000');
					var getDate = getNextMonday(new Date(), this.days);
					var date = formatDate(getDate);
					this.campaingUpdate = new CampaignUpdate(
						campaignId,
						leadsAssigned,
						date,
					);
					Promise.resolve(
						this.forecastWeekEditable.updateWeekForecast(
							this.campaingUpdate,
						),
					);
				}
			};

			var tableWeek = jspreadsheet(this.sheet.nativeElement, {
				data: value.body,
				csvHeaders: true,
				search: true,
				pagination: 100,
				tableOverflow: true,
				freezeColumns: 3,
				tableWidth: '1100px',
				tableHeight: '1100px',
				columns: [
					{ title: 'Row', width: 80, type: 'hidden', readOnly: true },
					{
						title: 'Campaign ID',
						width: 80,
						type: 'hidden',
						readOnly: true,
					},
					{ title: 'Campaign', width: 100, readOnly: true },
					{ title: 'Industry', width: 100, readOnly: true },
					{
						title: 'Lead Cost',
						width: 70,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{ title: 'Leads', width: 70, type: 'numeric' },
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{ title: 'Leads', width: 70, type: 'numeric' },
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{ title: 'Leads', width: 70, type: 'numeric' },
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{ title: 'Leads', width: 70, type: 'numeric' },
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{ title: 'Leads', width: 70, type: 'numeric' },
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{ title: 'Leads', width: 70, type: 'numeric' },
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{ title: 'Leads', width: 70, type: 'numeric' },
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{ title: 'Leads', width: 70, type: 'numeric' },
					{ title: 'LeadsX', width: 70, type: 'hidden' },
					{ title: 'Leads', width: 70, readOnly: true },
					{
						title: 'Income',
						width: 100,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
				],
				footers: [
					[
						'',
						'',
						'',
						'',
						'Total',
						'=ROUND(SUM(F1:F300),2)',
						'',
						'=ROUND(SUM(H1:H300),2)',
						'',
						'=ROUND(SUM(J1:J300),2)',
						'',
						'=ROUND(SUM(L1:L300),2)',
						'',
						'=ROUND(SUM(N1:N300),2)',
						'',
						'=ROUND(SUM(P1:P300),2)',
						'',
						'=ROUND(SUM(R1:R300),2)',
						'',
						'=ROUND(SUM(T1:T300),2)',
						'',
						'=ROUND(SUM(V1:V300),2)',
						'=ROUND(SUM(W1:W300),2)',
					],
				],
				onchange: changed,
				nestedHeaders: [
					[
						{
							title: 'Campaign Info',
							colspan: 3,
						},
						{
							title: monday_1,
						},
						{
							title: monday_2,
						},
						{
							title: monday_3,
						},
						{
							title: monday_4,
						},
						{
							title: monday_5,
						},
						{
							title: monday_6,
						},
						{
							title: monday_7,
						},
						{
							title: monday_8,
						},
						{
							title: 'Totals',
							colspan: 2,
						},
					],
				],
				updateTable: function (
					instance,
					cell,
					col,
					row,
					val,
					label,
					cellName,
				) {
					if (
						col == 5 ||
						col == 7 ||
						col == 9 ||
						col == 11 ||
						col == 13 ||
						col == 15 ||
						col == 17 ||
						col == 19
					) {
						for (var i = 1; i < 150; i++) {
							var valueG = instance.jexcel.getValue('G' + i);

							if (cellName == 'F' + i && valueG == 0) {
								cell.style.backgroundColor = '#fff8b0';
							}
							if (cellName == 'F' + i && valueG > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueI = instance.jexcel.getValue('I' + i);
							if (cellName == 'H' + i && valueI == 0) {
								cell.style.backgroundColor = '#fff8b0';
							}
							if (cellName == 'H' + i && valueI > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueK = instance.jexcel.getValue('K' + i);
							if (cellName == 'J' + i && valueK == 0) {
								cell.style.backgroundColor = '#fff8b0';
							}
							if (cellName == 'J' + i && valueK > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueM = instance.jexcel.getValue('M' + i);
							if (cellName == 'L' + i && valueM == 0) {
								cell.style.backgroundColor = '#fff8b0';
							}
							if (cellName == 'L' + i && valueM > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueO = instance.jexcel.getValue('O' + i);
							if (cellName == 'N' + i && valueO == 0) {
								cell.style.backgroundColor = '#fff8b0';
							}
							if (cellName == 'N' + i && valueO > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueQ = instance.jexcel.getValue('Q' + i);
							if (cellName == 'P' + i && valueQ == 0) {
								cell.style.backgroundColor = '#fff8b0';
							}
							if (cellName == 'P' + i && valueQ > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueS = instance.jexcel.getValue('S' + i);
							if (cellName == 'R' + i && valueS == 0) {
								cell.style.backgroundColor = '#fff8b0';
							}
							if (cellName == 'R' + i && valueS > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}

							var valueU = instance.jexcel.getValue('U' + i);
							if (cellName == 'T' + i && valueU == 0) {
								cell.style.backgroundColor = '#fff8b0';
							}
							if (cellName == 'T' + i && valueU > 0) {
								cell.style.backgroundColor = '#dcfce4';
							}
						}
					}

					if (col > 4 && col < 21) {
						if (val <= 0) {
							cell.style.backgroundColor = '#fcd7d8';
						}
					}
				},
			});
		});
	}

	selectEventCampaign(item: any) {
		this.selectedCampaign = item.id;
	}

	search_weeks(event: any) {}
}

function getNextMonday(date = new Date(), int: number) {
	const dateCopy = new Date(date.getTime());

	const nextMonday = new Date(
		dateCopy.setDate(
			dateCopy.getDate() + ((int - dateCopy.getDay() + 1) % int || int),
		),
	);

	return nextMonday;
}

function formatDate(fecha: any) {
	var d = new Date(fecha),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = '0' + month;
	if (day.length < 2) day = '0' + day;

	return [year, month, day].join('-');
}
